import { useDispatch } from 'react-redux'
import { bindActionCreators } from '@reduxjs/toolkit'
import { authActions } from 'store/auth'
import { customerAddActions } from 'store/customerAdd'
import { globalActions } from 'store/global.slice'
import { orderAddActions } from 'store/orderAdd'
import { orderListActions } from 'store/orderList.slice'

const allActions = {
  ...globalActions,
  ...authActions,
  ...orderListActions,
  ...customerAddActions,
  ...orderAddActions
}

export const useActions = () => {
  const dispatch = useDispatch()

  return bindActionCreators(allActions, dispatch)
}
